import { useRouteMatch } from 'react-router-dom';
import AuthRoutes from '@/constants/routing/AuthRoutes';

export const FeedTypes = {
  CAMPAIGN: 'campaign',
  CONSTITUENT: 'constituent',
  CONSTITUENT_DONATION: 'constituent-donation',
  HOME: 'home',
  TASK: 'task',
};

const useFeedType = () => {
  const match = useRouteMatch();
  switch (match.path) {
    case AuthRoutes.CAMPAIGN:
    case AuthRoutes.CAMPAIGN_FEED:
      return FeedTypes.CAMPAIGN;
    case AuthRoutes.CONSTITUENT:
    case AuthRoutes.CONSTITUENT_HISTORY:
      return FeedTypes.CONSTITUENT;
    case AuthRoutes.TASK:
      return FeedTypes.TASK;
    case AuthRoutes.LANDING:
    case AuthRoutes.FEED:
    default:
      return FeedTypes.HOME;
  }
};

export default useFeedType;
